export default "__VITE_ASSET__1614c56a__"